module.exports = __webpack_public_path__ + "static/img/download-gray.bcdd1148.svg";